<template>
	<div
		class="flow-env-status-card"
		:disabled="disabled"
		:state="state"
		@click="handleClick($event)"
	>
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "EnvironmentStatusCard",
	props: {
		/**
		 * true | false
		 */
		disabled: {
			type: Boolean,
			default: false
		},
		state: {
			type: String,
			default: "default",
			validator(value) {
				return ["error", "warning", "default", "success", "primary"].includes(value);
			}
		}
	},
	methods: {
		handleClick(e) {
			/**
			 * Click event.
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
$env-status-colors: (
	"default": var(--dashboard-element-light),
	"error": var(--dashboard-danger-light),
	"success": var(--dashboard-success-light),
	"warning": var(--dashboard-warning-light),
	"Primary": var(--dashboard-primary-light)
);

div.flow-env-status-card {
	border-radius: 8px;
	background-color: var(--dashboard-element-light);
	cursor: default;
	position: relative;

	display: flex;
	flex-direction: column;
	flex: 0 0 auto;
	// width: 110px;
	min-height: 100px;
	max-height: 100px;
	width: 100px;
	overflow: hidden;
	cursor: pointer;

	@each $state, $color in $env-status-colors {
		&[state="#{$state}"] {
			background: $color;
		}
	}

	&:not([disabled]) {
		// &:active {
		// 	filter: contrast(90%);
		// }

		// &:hover:not(:active) {
		// 	filter: contrast(95%);
		// }
		&:focus-within {
			box-shadow: inset 0 0 0 2px var(--dashboard-primary);
			outline: none;
		}
	}

	&[disabled] {
		filter: opacity(0.4);
		pointer-events: none;
		&:before {
			content: "";
			position: absolute;
			border-radius: 8px;
			top: 0px;
			bottom: 0px;
			left: 0px;
			right: 0px;
			background-color: var(--dashboard-element-light);
			opacity: 0.7;
		}
	}
}
</style>
